import parseFilenameFromContentDisposition from "./parseFilenameFromContentDisposition";

// 파일 다운로드 응답(blob)을 브라우저 저장으로 연결하는 공통 처리.
// noticeAPI(엑셀)·fulfillAPI(zip) 의 RTK Query responseHandler 와 mock Response 가 함께 쓴다.
//  1. 실패 응답이면 다운로드를 트리거하지 않고 반환 (RTK Query 가 error 로 처리)
//  2. Content-Disposition 헤더에서 파일명 추출 (추출 실패 시 defaultFilename)
//  3. blob → ObjectURL → a[download] 클릭 → ObjectURL 해제
const downloadBlobResponse = async (response: Response, defaultFilename: string): Promise<undefined> => {
  if (!response.ok) {
    return undefined;
  }
  const filename = parseFilenameFromContentDisposition(response.headers.get("content-disposition"), defaultFilename);

  // Blob URL 생성
  const blob = await response.blob();
  const blobUrl = window.URL.createObjectURL(blob);

  // 링크 요소 생성 및 클릭으로 다운로드 시작
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();

  // 정리
  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
  return undefined;
};

export default downloadBlobResponse;
